<template>
  <b-modal id="createCarUserDataModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmcaruserdata.createCarUserDataModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="serviceman">
      <b-col>
        <EXCMCarUserDataCreate :serviceman="serviceman"></EXCMCarUserDataCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMCarUserDataCreate from '../Create.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'CreateCarUserDataModal',
  components: {
    EXCMCarUserDataCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdata.assignCarCreate.show
    },
    create () {
      return this.$store.state.modals.userdata.assignCarCreate.create
    },
    servicemanObject () {
      return this.$store.state.modals.userdata.assignCarCreate.serviceman
    },
    close () {
      return this.$store.state.modals.userdata.assignCarCreate.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'servicemanObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      serviceman: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.servicemanObject) {
        this.serviceman = Object.assign({}, this.servicemanObject)
        this.$store.state.modals.userdata.assignCarCreate.show = 0
        this.$store.state.modals.userdata.assignCarCreate.serviceman = null
        this.$bvModal.show('createCarUserDataModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdata.assignCarCreate.close = 0
        this.$bvModal.hide('createCarUserDataModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
